<template>
  <div>
    <div>
      <div class='attachment'>
        <span class='uploadNum'>{{UploadedTitle}}</span>
        <span class='uploadClick' @click='handlerUploadClick'>{{titleName}}</span>
      </div>
    </div>
    <lk-modal
      v-model="attachmentShow"
      title="上传附件"
      transfer
      :closable='false'
      :mask-closable='false'
      style="width: 550px"
    >
      <div class='add_attachment' @click='handlerAddClick' v-if="isCanEdit">+ 添加附件</div>
      <table class='common_table'>
        <thead>
          <tr>
            <td>序号</td>
            <td style="width: 30%">附件名称</td>
            <td style="width: 32%">附件</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="(item, index) in tempInfo"
          >
            <tr :key='index'>
              <td>{{index+1}}</td>
              <td style="width: 30%">
                <lk-input
                  :disabled="!isCanEdit"
                  class='name_input'
                  @on-change='inputCheck'
                  :maxlength='16'
                  v-model.trim='item.appendixName'
                ></lk-input>
              </td>
              <td style="width: 32%">
                <Uploader
                  :able='isCanEdit'
                  :showDetIcon='false'
                  :upIndex='index'
                  :maxSize='10'
                  v-model.trim='item.appendixUrl'
                  @handlerUploadName='handlerUploadName'
                  @deleteUpload='deleteUpload'
                ></Uploader>
              </td>
              <td class='del_attacnment'>
                <lk-button type="text-primary" :disabled="!isCanEdit" @click='handlerDelClick(index)'>删除附件</lk-button>
              </td>
            </tr>
        </template>
        </tbody>
      </table>
      <div slot="footer">
        <lk-button type="default" size="large"  @click="handlerCancel">取消</lk-button>
        <lk-button type="primary" size="large"  @click="handlerOK" >确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import Uploader from '../Uploader.vue';
import utils from '../../libs/utils.js';

export default {
  name: 'Attachment',
  components: {
    Uploader,
  },
  props: {
    attachmentConfirm: {
      type: Function,
    },
    uploadInfo: {
      type: Array,
      default: () => [],
    },
    isCanEdit: {
      type: Boolean,
      default: true,
    },
  },
  model: {
  },
  computed: {
    infoLength() {
      return this.tempInfo.length;
    },
    UploadedNum() {
      return this.tempInfo.filter(item => item.appendixUrl && item.appendixUrl !== '').length;
    },
    UploadedTitle() {
      return this.UploadedNum === 0 ? '未上传' : `已上传${this.UploadedNum}个附件`;
    },
    titleName() {
      if (!this.isCanEdit) {
        return '查看'
      }
      return this.UploadedNum === 0 ? '上传附件' : '管理附件';
    },
  },
  watch: {
    uploadInfo: {
      handler() {
        if (this.uploadInfo.length) {
          this.tempInfo = utils.deepClone(this.uploadInfo);
        } else {
          this.setTempInfo();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      attachmentShow: false,
      tempInfo: [],
    };
  },
  methods: {
    inputCheck(e) {
      if (e.target.value.replace(/^ +| +$/g, '') == '') {
        this.$Message.warning('请输入附件名称');
      }
    },
    deleteUpload(index) { // 删除附件，清空名字
      this.uploadInfo[index].appendixName = '';
      this.uploadInfo[index].appendixUrl = '';
    },
    handlerUploadClick() { // 上传附件
      this.attachmentShow = true;
    },
    handlerUploadName(index, name) {
      this.tempInfo[index].appendixName = name.length > 16 ? name.substring(0, 16) : name;
    },
    handlerAddClick() {
      if (this.infoLength === 5) {
        this.$Message.warning('无法新增，最多上传5个附件');
      } else {
        this.tempInfo.push({
          appendixName: '',
          appendixUrl: '',
        });
      }
    },
    setTempInfo() {
      this.tempInfo = [
        {
          appendixName: '',
          appendixUrl: '',
        },
      ];
    },
    handlerDelClick(index) {
      if (this.infoLength > 1) {
        this.tempInfo.splice(index, 1);
      } else if (this.infoLength === 1) {
        this.setTempInfo();
      }
    },
    handlerOK() {
      const list = this.tempInfo.filter(item => item.appendixUrl);
      let result = true;
      if (list.length) {
        result = list.reduce((pre, item) => (item.appendixName.replace(/^ +| +$/g, '') !== '' && item.appendixUrl !== '') && pre, true);
      }
      if (!result) {
        this.$Message.warning('请输入附件名称');
        return;
      }
      this.attachmentShow = false;
      const info = this.tempInfo.filter(item => item.appendixUrl && item.appendixUrl !== '');
      this.$emit('attachmentConfirm', info);
      if (info.length === 0) {
        this.setTempInfo();
      } else {
        this.tempInfo = info;
      }
    },
    handlerCancel() {
      this.attachmentShow = false;
      if (this.uploadInfo.length) {
        this.tempInfo = utils.deepClone(this.uploadInfo);
      } else {
        this.setTempInfo();
      }
    },
  },
};


</script>
<style lang="less" scoped>
.add_attachment, .del_attacnment {
  margin-bottom: 10px;
  color: #2d8cf0;
  cursor: pointer;
}
.del_attacnment {
  color: #2d8cf0;
}
.name_input {
  padding: 0 4px;
}
table.common_table tr td {
  border:1px solid #e8eaec;
  height: 40px;
}
table.common_table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}
thead td {
  background-color: #f8f8f9
}
/deep/ .uploaderContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.attachment {
  .uploadNum {
    padding:0 10px 0 4px;
  }
  .uploadClick {
    cursor: pointer;
    font-weight: 500;
    color: #2d8cf0;
  }
}
</style>
